export default __webpack_public_path__ + "static/media/skillwavebtm.6fae46b7.png";